<template>
  <div class="container pb-5" id="printMe">
    <div class="d-flex align-self-auto">
      <legend>Список партнеров</legend>
      <div class="d-flex flex-row align-items-start">
        <select name="" id="" class="form-control" style="width: 400px" v-model="currentTourId">
          <option value="">Все</option>
          <option :value="tour.Id" v-for="tour in tours">{{ tour.Name }}</option>
        </select>
        <button class="btn btn-warning ml-2 d-print-none" @click.prevent="print">Печать</button>
      </div>
    </div>
    <table class="table table-hover table-bordered table-sm">
      <thead>
        <tr>
          <th width="90">Объезд</th>
          <th>Пункт</th>
          <th width="270">Телефон</th>
          <th width="100">Долг</th>
          <th width="70" class="text-nowrap">Не активен</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in activeCustomers">
          <td>{{ item.TourName }}</td>
          <td>
            <router-link :to="{ name: 'partner', params: {id: item.CustomerId}}"
                         target="_blank">
              {{ item.Reception }}
            </router-link>
          </td>
          <td>{{ item.UserPhone }} {{ item.DirectorPhone }}</td>
          <td>{{ pointDebt[item.Id] }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <legend>Неактивные партнеры</legend>
    <table class="table table-hover table-bordered table-sm">
      <thead>
        <tr>
          <th width="90">Объезд</th>
          <th>Пункт</th>
          <th width="270">Телефон</th>
          <th width="100">Долг</th>
          <th width="70" class="text-nowrap">Не активен</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in inActiveCustomers">
          <td>{{ item.TourName }}</td>
          <td>
            <router-link :to="{ name: 'partner', params: {id: item.CustomerId}}"
                         target="_blank">
              {{ item.Reception }}
            </router-link>
          </td>
          <td>{{ item.UserPhone }} {{ item.DirectorPhone }}</td>
          <td>{{ pointDebt[item.Id] }}</td>
          <td>+</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { get, post } from '@/admin/services/api/http-utils';
import _ from 'lodash';

const url = `${process.env.VUE_APP_API_HOST}admin/customer`;

export default {
  data() {
    return {
      items: [],
      pointDebt: [],
      currentTourId: null,
    };
  },
  computed: {
    activeCustomers() {
      if (!this.currentTourId) {
        return this.items.active;
      }
      return _.filter(this.items.active, { TourId: this.currentTourId });
    },
    inActiveCustomers() {
      if (!this.currentTourId) {
        return this.items.inactive;
      }
      return _.filter(this.items.inactive, { TourId: this.currentTourId });
    },
    tours() {
      return this.items.tours || [];
    },
  },
  async mounted() {
    await this.fetchItems();
    await this.fetchPointDebt();
  },
  methods: {
    async fetchItems() {
      const { data } = await get(`${url}/all-customer-list`);
      this.items = data;
    },
    async fetchPointDebt() {
      const pointIds = _.merge(_.map(this.items.active, p => p.Id), _.map(this.items.inactive, p => p.Id));
      const { data } = await post(`${process.env.VUE_APP_API_HOST}admin/delivery/point-debt`, { pointIds });
      this.pointDebt = data;
    },
    print() {
      this.$htmlToPaper('printMe');
    },
  },
};
</script>
